import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

export function ViewWrap(props) {
  const className = `design-view ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

ViewWrap.propTypes = {
  /**
   * components to render in wrapper
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

ViewWrap.defaultProps = {
  className: "",
};
